/**
 * Created by jv on 2019-09-10 (14:33).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/introduction.html";
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

require("Styles/components/views/introduction.scss");

class IntroductionView extends GameView {
  constructor(options) {
    options.html = $(htmlView);
    super(options);

    this.path = "introduction";
    this.videoLink = options.videoLink;
    this.onIntroductionCompleted = options.onIntroductionCompleted;

    this.$video = null;
  }

  render() {
    super.render();
    this.setUpVideo();
    this._setUpEventListeners();

    this.onRender();
  }

  setUpVideo() {
    this.$video = $("<video controls class='embed-responsive-item'></video>");
    this.$video.append(`<source src='${this.videoLink}' type="video/mp4">`);
    this.$video.append(utils.format(LanguageManager.getValueForKey("global.video.unsupported"), this.videoLink));

    this.$element.find(".introduction-video").append(this.$video);

    this.$video.on("ended", (e) => {
      if (utils.isFunction(this.onIntroductionCompleted)) {
        this.onIntroductionCompleted.call(this, false);
      }
    });
  }

  setLoadingState(flag) {
    let $skipBtn = this.$element.find(".skip-intro-btn");

    $skipBtn.removeClass("btn-loading").prop("disabled", flag);

    if (flag) {
      $skipBtn.addClass("btn-loading");
    }
  }

  _setUpEventListeners() {
    this.$element.find(".skip-intro-btn").off("click").on("click", (e) => {
      this.$video.trigger("pause");

      if (utils.isFunction(this.onIntroductionCompleted)) {
        this.onIntroductionCompleted.call(this, true);
      }
    });
  }
}

module.exports = IntroductionView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/introduction.js